import { IIconBase } from '..'

const noUpdateIcon = ({ height = 18, width = 18 }: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='icon-wrapper' clipPath='url(#clip0_5513_19792)'>
        <path
          id='Union'
          d='M15.9997 7.99927C15.9997 10.121 15.1568 12.1558 13.6565 13.6561C12.1562 15.1564 10.1214 15.9993 7.99966 15.9993C5.87793 15.9993 3.8431 15.1564 2.34281 13.6561C0.842519 12.1558 -0.000335693 10.121 -0.000335693 7.99927C-0.000335693 5.87754 0.842519 3.8427 2.34281 2.34241C3.8431 0.842122 5.87793 -0.000732422 7.99966 -0.000732422C10.1214 -0.000732422 12.1562 0.842122 13.6565 2.34241C15.1568 3.8427 15.9997 5.87754 15.9997 7.99927ZM12.0297 4.96927C11.9582 4.89809 11.8732 4.84204 11.7796 4.80448C11.686 4.76692 11.5858 4.74863 11.485 4.75068C11.3842 4.75273 11.2848 4.7751 11.1928 4.81644C11.1008 4.85777 11.0181 4.91724 10.9497 4.99127L7.47666 9.41627L5.38366 7.32227C5.24149 7.18979 5.05344 7.11766 4.85914 7.12109C4.66484 7.12452 4.47946 7.20323 4.34204 7.34065C4.20463 7.47806 4.12592 7.66344 4.12249 7.85775C4.11906 8.05205 4.19118 8.24009 4.32366 8.38227L6.96966 11.0293C7.04095 11.1004 7.12583 11.1565 7.21925 11.1941C7.31267 11.2318 7.41271 11.2502 7.51341 11.2483C7.61411 11.2465 7.7134 11.2243 7.80536 11.1833C7.89732 11.1422 7.98007 11.083 8.04866 11.0093L12.0407 6.01927C12.1768 5.87777 12.2519 5.68854 12.2501 5.49223C12.2482 5.29591 12.1694 5.10815 12.0307 4.96927H12.0297Z'
          fill='#055160'
        />
      </g>
      <defs>
        <clipPath id='clip0_5513_19792'>
          <rect width={width} height={height} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default noUpdateIcon
